export const FOLDER_DASHBOARD_WIDGET_SETTINGS_KEY = 'folder_dashboard_widget_settings';

export const SERVICE_DASHBOARD_WIDGET_SETTINGS_KEY = 'service_dashboard_widget_settings';

export const FOLDER_DASHBOARD_BASIC_INFO_PROPERTIES_KEY = 'folder_dashboard_basic_info_properties';
